export const API_URL = import.meta.env.VITE_API_URL;
export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;
export const EXTERNAL_TEST_USER_EMAILS =
  import.meta.env.VITE_EXTERNAL_TEST_USER_EMAILS || '';
